export default __webpack_public_path__ + "5af5156a99528e7617731e72109cf2df.otf";